// eslint-disable-next-line
export default [
	{
		imgSrc: "/svgs/fb.svg",
		link: "https://www.facebook.com/SippyLife",
	},
	{
		imgSrc: "/svgs/Instagram.svg",
		link: "https://www.instagram.com/sippy_official",
	},
	{
		imgSrc: "/svgs/Twitter.svg",
		link: "https://www.x.com/Sippy_Life",
	},
	{
		imgSrc: "/svgs/Youtube.svg",
		link: "https://www.youtube.com/@SippyLife",
	},
	{
		imgSrc: "/svgs/whatsapp.svg",
		link: "https://wa.me/2348161185271",
	},
	{
		imgSrc: "/svgs/linkedIn.svg",
		link: "https://www.linkedin.com/company/sippy-life",
	},
];
